import { Loader } from "@circle-react-shared/uikit/Loader";
import { PageOverlay } from "@circleco/compass/components/PageOverlay";

interface CompassEventModalSuspenseFallbackProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Visible shell while the lazy CompassEventModal chunk loads. */
export const CompassEventModalSuspenseFallback = ({
  isOpen,
  onClose,
}: CompassEventModalSuspenseFallbackProps) => (
  <PageOverlay open={isOpen} onOpenChange={onClose}>
    <div className="flex size-full items-center justify-center bg-secondary">
      <Loader />
    </div>
  </PageOverlay>
);
